import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Rider } from './rider';

@inheritSerialization(AbstractModel)
export class TransitProgramRider extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserializeAs(Rider)
  rider: Rider;

  @autoserialize
  active: boolean;

  @autoserialize
  transitProgramIdentifier: string;

  @autoserialize
  accessibilityRequirements: string;

  @autoserialize
  createdByUserId: number;

  constructor() {
    super();
    this.rider = new Rider();
    this.active = true;
  }
}
